import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F9F6]">
        <div className="text-[#5C6A61]" data-testid="auth-loading">Memuat...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/owner/login" replace />;
  return children;
}
